import { Alert } from './Alert';

// TODO: in v9, move styled() from Alert.jsx to here
export var StyledAlert = Alert;